import { required, minLength } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  description: {
    required,
  },
  startDate: {
    required,
  },
  endDate: {
    required,
  },
  businessType: {
    required,
  },
  // discount: {
  //   required,
  // },
  productSaleItems: {
    required,
    minLength: minLength(1),
    // $each: {
    //   salePrice: {
    //     required,
    //   },
    //   discount: {
    //     required,
    //   }
    // },
  }
};

export default validations;